// I'll pay for this one day...
// const originalToJson = Date.prototype.toJSON;
//
// Date.prototype.toJSON = function (...args: any): string {
//
//   const thisArg = new Date(this.getTime() - (this.getTimezoneOffset() * 60000));
//
//   return originalToJson.apply(thisArg, args);
// };
